import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var parkingIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.188 22.966H3.694A2.756 2.756 0 0 1 .94 20.213V3.72A2.756 2.756 0 0 1 3.694.966h15.242a4.01 4.01 0 0 1 4.005 4.006v15.241a2.757 2.757 0 0 1-2.753 2.753ZM3.694 2.466c-.69 0-1.253.562-1.253 1.253v16.494c0 .69.562 1.253 1.253 1.253h16.494c.69 0 1.253-.562 1.253-1.253V4.972a2.508 2.508 0 0 0-2.505-2.506H3.694Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.596 9.121c0 .618-.102 1.175-.306 1.673-.204.496-.495.92-.874 1.27s-.844.621-1.395.813c-.551.19-1.209.286-1.973.286h-1.405v4.452c0 .051 0 .454-.01.5-.012.05-.01.082-.04.187-.035.13-.097.281-.165.368a1.316 1.316 0 0 1-.279.27c-.126.088-.276.137-.384.161s-.408.049-.384.047-.318.005-.343-.033c-.026-.038-.038-1.449-.038-1.5V6.207c0-.255.067-.436.2-.544a.695.695 0 0 1 .45-.163h2.646c.268 0 .524.011.77.034s.534.07.869.143c.334.073.675.21 1.022.41.348.201.642.448.884.741s.428.632.56 1.018c.13.385.195.81.195 1.275Zm-1.63.134c0-.503-.094-.923-.283-1.261-.187-.338-.42-.59-.697-.755-.277-.166-.563-.27-.86-.315s-.584-.067-.864-.067h-1.52v4.959h1.481c.497 0 .91-.064 1.238-.191.328-.127.603-.304.826-.53.223-.226.392-.498.506-.813.115-.315.173-.657.173-1.027Z"
}));

export { parkingIcon as default };
//# sourceMappingURL=parkingIcon.js.map
